
  import { defineComponent, ref, onMounted, reactive } from "vue";
  import mAxiosApi from "@/api";
  import * as moment from "moment";
  import EtatAddEdit from "./EtatAddEdit.vue";
  import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
  import CardEtatEmp from "./CardEtatEmp.vue";
  import { ElMessage, ElMessageBox } from "element-plus";
   
  export default defineComponent({
    name: "General",
    components : {
        CardEtatEmp,
        EtatAddEdit,
    },
    setup() {

    const dialogImageUrl = ref('')
    const dialogVisible = ref(false)
    const disabled = ref(false)

    const state = reactive({
        allEtat : {} as any,
        EtatAddEdit : 0,
        openCloseEtatAddEdit : 0,
        loading : true,
        moisCourant: ''
    });
    
    onMounted(async() => {
      setCurrentPageBreadcrumbs("Saisie employé", ["Pages", "Profile"]);

      computeMoisCourant();

      await refresh();

      state.loading = false;

      console.log('current month :', state.moisCourant);

    });

    const computeMoisCourant = () => {
      // Récupérer le jour actuel
      const jourActuel = moment.default().date();
      
      let lib;
      
      // Appliquer la même logique que le backend
      if (jourActuel >= 1 && jourActuel <= 31) {
        // Du 1er au 20 : mois courant
        lib = moment.default().add(-1, 'month').locale('fr').format('MMMM YYYY');
      } else {
        // Du 21 au dernier jour : mois suivant
        lib = moment.default().locale('fr').format('MMMM YYYY');
      }
      
      // Mettre une majuscule au mois
      state.moisCourant = lib.charAt(0).toUpperCase() + lib.slice(1);
    };
  

      const toDate = (d) => {
        return moment.default(d).format("DD.MM.YYYY");
      };


      const openEtatEmp = (id = 0) =>{
        state.EtatAddEdit = id;
        state.openCloseEtatAddEdit = 1;
      }

      const refresh = async () => {
        const getEtatEmp = await mAxiosApi.prototype.getAxios("/getEtatEmp");
        state.allEtat = getEtatEmp.results;

      };

      const checkMonth = (mois) => {

        const list = Array.isArray(state.allEtat) ? state.allEtat : [];
        const filteredList = list.filter(el => el.eem_libelle === mois);

        if (filteredList.length > 0) {
            ElMessage({
            type: 'error',
            message: `Vous avez déjà crée une saisie pour ${mois} ! Si votre saisie a été refusé, veuillez la modifier et la renvoyer au service RH svp.`,
          })
          return
        } else {
          openEtatEmp();
        }
      };
     
      return {
          disabled,
          dialogImageUrl,
          dialogVisible,
          state,
          toDate,
          openEtatEmp,
          refresh,
          computeMoisCourant,
          checkMonth
      };
    },
  });
  